import { Dispatch } from 'redux';
import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { selectOrderItem, selectPage, setPageLoading } from '../actions';
import { asyncEventUpdate } from '../../events/initiators';
import { osName, osVersion, browserName, browserVersion, mobileVendor, mobileModel, deviceType } from 'react-device-detect';
import { eventFlowUpdate } from '../../events/actions';
import { MarketEventFlow } from '../../events/types';
import { fetchOtherItemsFromBusiness } from './fetchOtherItemsFromBusiness';
import { asyncGetSoldOutEstimate } from './asyncGetSoldOutEstimate';

// Thunk action to fetch page
export const fetchPage = (pageKey: string, newFetch?: boolean) => {
  return async (dispatch: Dispatch<any>, getState: () => ReduxState) => {
    try {
      const response = await backend.get(`/marketplace-service/api/v1/items/p/${pageKey}?includeViewCount=1&includeCheckoutCount=1`);

      if (response.status === 200) {
        dispatch(selectPage(response.data));
        const { _id, price, name, status, currency } = response.data;
        const quantity = parseInt(response.data.pageData.quantityOrderLimitMin) || 1;
        dispatch(selectOrderItem({
          _id, price, name, status, currency,
          quantity, data: {
            details: '', addOns: []
          } 
        }))
        dispatch(setPageLoading(false));
        
        // setup market events
        if (response.data.pageData && response.data.associatedBusinesses && response.data.associatedBusinesses.length > 0) {
          
          // get current event flow
          const { eventFlow } = getState().events;

          // get userId
          let userId = eventFlow.userId;
          const { user } = getState().user;
          if (!user) {
            userId = null;
          }
          if (user && userId !== user?._id) {
            userId = user._id;
          }

          // send page-exit if navigating to a new page
          const newBusiness = eventFlow.businessId && eventFlow.businessId !== response.data.associatedBusinesses[0]._id;
          const newItem = eventFlow.itemId && eventFlow.itemId !== response.data._id;
          const newUser = eventFlow.userId && userId && eventFlow.userId !== userId

          if (newBusiness || newItem || newUser) {
            dispatch(asyncEventUpdate('page-view')); // send final page view update
            dispatch(asyncEventUpdate('page-exit')); // exit the page
          }

          const eventUpdate: MarketEventFlow = {
            ...eventFlow,
            businessId: response.data.associatedBusinesses[0]._id,
            event: 'page-view',
            itemId: response.data._id,
            userId,
            data: {
              osName, osVersion, browserName, browserVersion, 
              mobileVendor, mobileModel, deviceType        
            }
          }
          dispatch(eventFlowUpdate(eventUpdate))
          dispatch(asyncEventUpdate('page-view'));
          dispatch(asyncGetSoldOutEstimate(response.data._id));
          // check if items from other businesses needs to be updated too and fetch
          let shouldUpdateOtherItems = false;
          const { otherItemsFromBusiness } = getState().page;
          if (!otherItemsFromBusiness.length) {
            shouldUpdateOtherItems = true;
          } else if (otherItemsFromBusiness.length > 0) {
            const itemToCompare = otherItemsFromBusiness[0];
            if (itemToCompare.associatedBusinesses?.length && itemToCompare.associatedBusinesses.length > 0) {
              const businessToCompare = itemToCompare.associatedBusinesses[0];
              if (response.data.associatedBusinesses._id !== businessToCompare._id) {
                shouldUpdateOtherItems = true;
              }
            }
          }
          if (shouldUpdateOtherItems || newFetch) {
            dispatch(fetchOtherItemsFromBusiness(response.data.associatedBusinesses[0]._id));
          }
        }       
      } else {
        dispatch(selectPage(null));
        dispatch(setPageLoading(false))
      }
    } catch (error) {
      console.error('Error fetching items:', error);
      dispatch(selectPage(null));
      dispatch(setPageLoading(false))
    }
  };
};